import * as Api from '../api';

const api = process.env.REACT_APP_ONB_API;

export const clearCacheOfAspynPushes = Api.post({ path: '/api/v1/reps/clear-cache-of-aspyn-pushes', api });

export const getMigrationJobs = Api.get({ path: '/api/v1/aspyn-migrator/migration-jobs', api });

export const migrateReps = Api.post({ path: '/api/v1/aspyn-migrator/migrate-reps', api });

export const migrateHousing = Api.post({ path: '/api/v1/aspyn-migrator/migrate-housing', api });
